"use client";

import getLogin from "@/firebase/firestore/getLogin";
import useUser from "@/hooks/useUser";
import { signOut } from "firebase/auth";

export default function Logout({ className }) {
	const { auth } = getLogin();
	const { user } = useUser();

	const logout = () => {
		signOut(auth);
	};
	return (
		user && (
			<div className={className} onClick={logout}>
				Logout
			</div>
		)
	);
}
